import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Router } from '@angular/router';
import { mergeMap, tap } from 'rxjs/operators';
import { AUTHENTICATION_CLEAR_STATE, CORE_CLEAR_STATE, LOGOUT, REDIRECT_TO, STATE_CLEAR_STATE } from '../actions';
import { Store } from '@ngrx/store';
import { selectCredential } from '@store/selectors';
import { Credential } from '@core/models';
import { Observable } from 'rxjs';

@Injectable()
export class CoreEffects {
  credential$: Observable<Credential | null>;

  constructor(
    private actions$: Actions,
    private router: Router,
    private store: Store,
  ) {
    this.credential$ = this.store.select(selectCredential)
  }

  redirectTo$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(REDIRECT_TO),
        tap(({ path }) => this.router.navigate([path]))
      ),
    { dispatch: false }
  );

  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LOGOUT),
      tap(() => {
        localStorage.clear();
        sessionStorage.clear();
      }),
      mergeMap(() => [
        CORE_CLEAR_STATE(),
        STATE_CLEAR_STATE(),
        AUTHENTICATION_CLEAR_STATE(),
        REDIRECT_TO({ path: '/login' })
      ])
    )
  );
}